var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assignments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SCORM",
    transform: "translate(-623.000000, -573.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(626.000000, 576.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert-octagon",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "49.49 0 70 20.51 70 49.49 49.49 70 20.51 70 0 49.49 0 20.51 20.51 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(18.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,30 L32,36.6666667 C32,38.5076158 30.557362,40 28.7777778,40 L6.22222222,40 C4.44263803,40 3,38.5076158 3,36.6666667 L3,30",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.554039,4.2840689 C16.485552,4.2840689 13.3679822,3.67166511 9.12360762,8.42338614 C4.87923306,13.1751072 4.89230605,23.7165202 7.24394428,24.493394 C8.30026834,24.8423551 10.2775018,27.4534858 13.3679822,26.9430091 C18.420445,26.1084578 22.2803707,19.2798854 22.554039,18.9817599 C25.0379838,16.2758305 26.6555261,4.2840689 22.554039,4.2840689 Z",
    id: "Oval",
    fill: "#7BC440",
    opacity: 0.894042969,
    transform: "translate(15.359909, 15.633637) rotate(45.000000) translate(-15.359909, -15.633637) "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "25 19 17 11 9 19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 11,
    x2: 17,
    y2: 30,
    id: "Path",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScormIcon);
export default __webpack_public_path__ + "static/media/scorm-icon.e76a312b0c24d163d5c359a5bceab736.svg";
export { ForwardRef as ReactComponent };